import React, { useState } from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';

interface CollapsibleSectionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  className?: string;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  children,
  defaultExpanded = false,
  className = "",
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`mt-6 border border-gray-300 rounded-lg shadow ${className}`}>
      <button
        onClick={toggleExpanded}
        className={`flex items-center justify-between w-full p-3 bg-gray-50 rounded-lg  transition-colors duration-200  ${isExpanded ? 'rounded-b-none' : ''}`}
        type="button"
      >
        <h3 className="text-lg font-semibold border-gray-200">
          {title}
        </h3>
        {isExpanded ? (
          <FaChevronDown className="w-4 h-4 text-gray-600" />
        ) : (
          <FaChevronRight className="w-4 h-4 text-gray-600" />
        )}
      </button>
      
      {isExpanded && (
        <div className={`p-4 bg-white rounded-lg rounded-t-none  ${isExpanded ? 'rounded-t-none' : 'rounded-t-lg'}`}>
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
